import { Text } from "@shared/primitive-components"

export const MapTitle = ({ title }: { title: string }): JSX.Element => (
  <Text
    tag="h2"
    use="headline2"
    css={() => ({
      marginTop: 20,
    })}
  >
    {title.toUpperCase()}
  </Text>
)
